var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWhiteChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9C1 5.68629 3.68629 3 7 3H17C20.3137 3 23 5.68629 23 9V15C23 18.3137 20.3137 21 17 21H3C1.89543 21 1 20.1046 1 19V9ZM5.41699 14.666C5.41699 13.9757 5.97664 13.416 6.66699 13.416H11.9997C12.69 13.416 13.2497 13.9757 13.2497 14.666C13.2497 15.3564 12.69 15.916 11.9997 15.916H6.66699C5.97664 15.916 5.41699 15.3564 5.41699 14.666ZM6.66699 9.08301C5.97664 9.08301 5.41699 9.64265 5.41699 10.333C5.41699 11.0234 5.97664 11.583 6.66699 11.583H17.3324C18.0227 11.583 18.5824 11.0234 18.5824 10.333C18.5824 9.64265 18.0227 9.08301 17.3324 9.08301H6.66699Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWhiteChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-white-chat.0ea5b2e30324f1daaf6fc63772fe7601.svg";